import isObject from 'lodash/isObject.js';
import isString from 'lodash/isString.js';
export function isOpenAPIServiceProvider(serviceProvider) {
    return serviceProvider.serviceType === 'openapi';
}
export function isAuthenticationServiceProvider(serviceProvider) {
    return serviceProvider.serviceType === 'authentication';
}
export function isOAuth2ServerAuthentication(maybeAuthentication) {
    return maybeAuthentication.type === 'oauth2';
}
export function isServiceFormData(maybeFormData) {
    return isString(maybeFormData.provider);
}
export function isOAuth2TokenResponse(maybeToken) {
    return isObject(maybeToken) && isString(maybeToken.access_token);
}
export function isOpenIdConfiguration(maybeConfig) {
    return isObject(maybeConfig) && isString(maybeConfig.jwks_uri);
}
export function isAIModelType(maybeType) {
    return ['generate', 'embedding', 'image'].includes(maybeType);
}
